var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.167 2.5V.833a.833.833 0 1 1 1.666 0V2.5a.833.833 0 1 1-1.666 0Zm-10 .833c.46 0 .833-.373.833-.833V.833a.833.833 0 1 0-1.667 0V2.5c0 .46.373.833.834.833ZM15 14.167v-2.5h-.833V15h2.5v-.833H15Zm-4.167.416a3.755 3.755 0 0 0 3.75 3.75 3.755 3.755 0 0 0 3.75-3.75 3.755 3.755 0 0 0-3.75-3.75 3.755 3.755 0 0 0-3.75 3.75Zm9.167 0a5.417 5.417 0 1 1-10.833 0 5.417 5.417 0 0 1 10.833 0ZM8.136 17.5h-6.47V6.667H17.5v1.469a7.07 7.07 0 0 1 1.667 1.057V1.667h-2.5V2.5a1.673 1.673 0 0 1-2.215 1.578c-.693-.223-1.119-.926-1.119-1.653v-.758h-7.5V2.5a1.673 1.673 0 0 1-2.215 1.578C2.926 3.855 2.5 3.152 2.5 2.425v-.758H0v17.5h9.193A7.107 7.107 0 0 1 8.136 17.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a048df27554caf94d7c3f4a4b5bd44db.svg";
export { ForwardRef as ReactComponent };